import React, { useEffect, useState, useRef } from 'react';
import coupon from '../../assets/images/coupon-icon.png';
import Axios from '../../lib/axios/axiosInstance';
import Moment from 'react-moment';
import "./MyWallet.styles.css";

const MyWallet = () => {

  const [wallet, setWallet] = useState(false);

  useEffect(async () => {
    // Get Wallet Details 
    // api/account/wallet
    await Axios.get(`/account/wallet`)
      .then(function (response) {
        if (response && response.data?.data?.vouchers) {
          setWallet(response.data?.data?.vouchers)
        }
      })
  }, [])

  const copyCouponCode = (value,id) =>{
    window.copyCouponCode(value,id);
  }
  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Wallet</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
        <div className="main">
          <div className="col-main">
            <div className="shopping-cart-inner"> 
              <div className="page-content">
                <div className="page-content checkout-page">
                  <div className="box-border" style={{ margin: "auto", width: "100%", padding: "0", borderRadius: "15px" }}>
                    {
                      wallet && wallet.map((data, i) => {
                        return (
                          <div key={i} className="col-sm-12 col-md-12">
                            <div className="coupon bg-white rounded mb-3 d-flex justify-content-between">
                              <div className="kiri">
                                <div className="icon-container ">
                                  <div className="icon-container_box">
                                    <img src={coupon} width="85" alt="totoprayogo.com" className="" />
                                  </div>
                                </div>
                              </div>
                              <div className="tengah py-3 d-flex w-100 justify-content-start" style={{ paddingLeft: "5%" }}>
                                <div className="tengah p2">
                                  <h3>Amount ${data.value}</h3>
                                  <p className="text-muted mb-0">Min Order: ${data.minorderamt}</p>
                                  <p className="text-muted mb-0">Expired on: <Moment date={data.expirydate} format="YYYY-MM-DD HH:mm:ss"/></p>
                                </div>
                              </div>
                              <div className="kanan">
                                <div className="info m-3 d-flex align-items-center">
                                  <div className="tengah p2" style={{ textAlign: "center" }}>
                                    <span className="badge badge-success" sty>Valid</span>
                                    <h3 className="leadsss" style={{margin:"0.5em 0"}}>{data.vouchercode}</h3>
                                    <button className={`text-muted mb-0 ${i}btn`} onClick={()=>copyCouponCode(data.vouchercode,i)}>Copy Code</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div>
    </div>
  );
};

export default MyWallet;
